/* eslint-disable react/prop-types */
import React from "react";
import { Avatar } from 'antd';

const NoDataForProject = ({project}) => {
  return (
    <div className="flex flex-col items-center justify-center text-2xl" style={{height: '150px', gap: '8px'}}>
      <Avatar src={project?.icon} size={40} >
        {project?.projectName?.charAt(0)?.toUpperCase()}
      </Avatar>
      <h3>No match result found in {project?.projectName}</h3>
      <span style={{color: '#959DA9'}}>Please try another search.</span>
    </div>
  );
};

export default NoDataForProject;
